export default __webpack_public_path__ + "static/media/shoutout-logo.8acbec1d.svg";